import { fetchData } from './fetchData';

type SatisfactionCheckRequestData = {
    // 報修單號
    name: string,
};

type SatisfactionCheckResponseData = {
    // 回饋否
    feedback_is: 'TRUE'|'FALSE',
};

function satisfactionCheck(data: SatisfactionCheckRequestData): Promise<SatisfactionCheckResponseData> {
    return fetchData('api/satisfaction_ckeck', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: SatisfactionCheckResponseData) => resData);
}

export { satisfactionCheck };
